import React, {Fragment} from "react";
import { makeStyles } from "@mui/styles";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 5,
    "@media (max-width:567px)": {
      marginTop: 40,
    },
  },
  h1: {
    textAlign: "center",
    color: "#000",
    fontFamily: "sans-serif",
    "@media (max-width:2000px)": {
      fontSize: "1.4rem",
    },
    "@media (max-width:1000px)": {
      fontSize: "1.3rem",
    },
    "@media (max-width:768px)": {
      fontSize: "1rem",
    },
    "@media (max-width:415px)": {
      fontSize: "1rem",
      marginRight: "10%",
    },
  },
  icon: {
    "margin-right": 10,
    width: "65px",
    height: "65px",
  },
  divider: {
    padding: '3px',
    background: '#205690',
    margin: '0 auto',
    marginBottom: '1rem',
    marginTop: (props) => props.showButton ? '1rem' : 0,
},
}));

function Titulo(props) {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.container}>
        {props.showIcon && (
          <img className={classes.icon} src={`/menu/${props.icon ? props.icon : "Formulario"}.png`} alt="Icon Formulario"/>
        )}
        <h2 className={classes.h1}>{props.title}</h2>
      </div>
      <Divider  className={classes.divider}/>
    </Fragment>
  );
}

Titulo.defaultProps = {
  showIcon: true,
  icon: "Formulario"
}

export default Titulo;
